/* AuditSummaryComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Registrations = require("../../../../../RegistrationNamespaces");
//const UserGridData = require('@gluenetworks/entity_grid_gl').UserData;
const BaseEntity = require("@gluenetworks/platform-sdk-remote/dist/entities/base_evented_sdk/BaseEntity");
const childViewComponent = require("../../../../widgets/childview/ChildViewRenderer");
const policyDetailsView = require("../../../auditpolicyeditor/views/audit_policy_details/AuditPolicyDetailsViewComponent");
const Renderer = require("./AuditSummaryViewRenderer");
const PagingFeed = require("./PagingAuditSummaryFeed");

const moment = require("moment-timezone");
const Checkmark = require("./column_renderers/checkmark/CheckmarkComponent");
const DateColumn = require("./column_renderers/date/DateComponent");
const ActionsColumn = require("./column_renderers/actions/ActionsComponent");

const AuditRun = require("./run_audit/RunAuditComponent");

class AuditViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        io,
        utils,
        userSession,
        storageFactory,
        solutionsManager,
        AuditSummary,
        muf,
        ConfigAuditPolicy,
        deviceEntity,
        customFieldsEntity,
        ConfigAuditExecution,
        userFeedback,
        siteEntityDef,
        commandSetEntityDef,
        tagsEntityDef
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._steveIo = io;
        this._fileFactory = io.fileFactory;
        this._modalUserFeedback = userFeedback;
        this._steveUtils = utils;
        this._userSession = userSession;
        this._AuditSummary = AuditSummary;
        this._ConfigAuditExecution = ConfigAuditExecution;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "AuditView";
        this._storageFactory = storageFactory;
        this._ConfigAuditPolicy = ConfigAuditPolicy;
        this._muf = muf;
        // this._baseEntity = BaseEntity;
        this._deviceEntityDef = deviceEntity;
        this._customFieldsEntityDef = customFieldsEntity;
        this._siteEntityDef = siteEntityDef;
        this._commandSetEntityDef = commandSetEntityDef;
        this._tagsEntityDef = tagsEntityDef;
        this._auditRun = new AuditRun({muf, logger, gameEditor, userSession, ConfigAuditPolicy});

        this._entity = undefined;
        this._pagingFeed = undefined;
        this._deviceEntity = undefined;
        this._auditSummaryEntity = undefined;

        this.columnConfig = {
            policyName: {
                label: "Audit Policy",
                // path: "data.sir",
                // columnRendererComponent: advisoryCriticalityColumn,
                sort: "asc",
                priority: 1,
                width: 300,
                reorder: false,
            },
            executedOn: {
                // sort: "desc",
                label: "Last Run",
                // path: "data.firstPublished",
                columnRendererComponent: DateColumn,
                priority: 2,
                width: 200,
                reorder: false,
            },
            ruleCount: {
                label: "Total Rules",
                priority: 3,
                width: 100,
                reorder: false,
            },
            criticalViolationCount: {
                label: "Critical",
                // path: "data.advisoryTitle",
                columnRendererComponent: Checkmark,
                context: {
                    severity: "critial",
                },
                priority: 4,
                width: 100,
                reorder: false,
            },
            majorViolationCount: {
                // sort: "desc",
                label: "Major",
                context: {
                    severity: "major",
                },
                columnRendererComponent: Checkmark,
                priority: 5,
                width: 100,
                reorder: false,
            },
            minorViolationCount: {
                label: "Minor",
                // entityColumn: true,
                // columnRendererComponent: advisoryReadMoreColumn,
                // resizable: false,
                // sortable: false,
                columnRendererComponent: Checkmark,
                context: {
                    severity: "minor",
                },
                width: 100,
                priority: 6,
                reorder: false,
            },
            infoViolationCount: {
                label: "Informational",
                columnRendererComponent: Checkmark,
                context: {
                    severity: "info",
                },
                sortable: true,
                priority: 7,
                width: 100,
                reorder: false,
            },
            violationCount: {
                label: "Violations",
                priority: 8,
                shown: true,
                width: 100,
                reorder: false,
            },
            errorCount: {
                label: "Errors",
                priority: 9,
                width: 100,
                reorder: false,
            },
            actionColumn: {
                label: "Actions",
                priority: 10,
                width: 100,
                columnRendererComponent: ActionsColumn,
                entityColumn: true,
                context: {
                    gameEditor: this._gameEditor,
                    parentContext: this,
                },
                reorder: false,
            },
        };

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this.on("GridAction", (this._onGridAction = this._onGridAction.bind(this)));
    }

    _unregisterListeners() {
        this.removeListener("GridAction", this._onGridAction);
    }

    _patchSorting(sorting) {
        let patchedSorting = _.clone(sorting);
        if (
            patchedSorting &&
            Object.keys(patchedSorting).length === 1 &&
            !patchedSorting.firstPublished
        ) {
            patchedSorting.firstPublished = -1;
        }
        return patchedSorting;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenFeedReady() {
        return this._pagingFeed.whenFeedReady();
    }

    wasFeedPreviouslyInitialized() {
        return this._pagingFeed.wasPreviouslyInitialized();
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let promArr = [this._renderer.shutdown()];
        if (this._childViewRenderer) {
            promArr.push(this._childViewRenderer.shutdown());
        }
        return Promise.all(promArr)
            .then(() => {
                if (!_.isUndefined(this._pagingFeed)) {
                    return this._pagingFeed.shutdown();
                } else {
                    return Promise.resolve();
                }
            })
            .then(
                () => {
                    this._logger = undefined;
                    this._gameEditor = undefined;
                    this._renderer = undefined;
                    this._steveIo = undefined;
                    this._steveUtils = undefined;
                    this._entity = undefined;
                    this._pagingFeed = undefined;
                },
                (err) => {
                    this._logger.warn({error: err}, "AuditViewComponent.shutdown() error.");
                }
            );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    get entityInstanceId() {
        // TODO To be reviewed -- Required
        return this._entityInstanceId;
    }

    whenModelIsReady() {
        return this._gameEditor
            .whenDeviceIsReady()
            .then(() => {
                this._deviceEntity = this._gameEditor.getDevice();
                this._auditRun.setDevice(this._deviceEntity);
                this._gridKey =
                    _.camelCase(this._solutionName) + "_" + this._deviceEntity.id + "_AuditView";
                this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    this._gridKey
                );
                return this._userGridData;
            })
            .then(() => {
                const userSorting = this._userGridData.getSorting() || {};
                const patchedSort = this._patchSorting(userSorting);
                this._pagingFeed = new PagingFeed({
                    feedKey: this._gridKey + "_feed",
                    userSession: this._userSession,
                    entityDef: this._deviceEntity,
                    columnConfig: this.columnConfig,
                    additionalDataFields: ["policyId", "executionId"],
                    sort: patchedSort,
                });
                this._registerListeners();
                return this._pagingFeed.whenFeedReady();
            });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnConfig[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columnConfig[sortData.sortColumn].valuePath ||
                this.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        sort = this._patchSorting(sort);

        this._pagingFeed.setSort(sort);
    }

    _onGridAction(data) {
        if (!data || !data.action || !data.entity) {
            return;
        }
        switch (data.action) {
            case "hide":
                this._hideResult(data.entity);
                break;
            case "run":
                this._auditRun.runAudit(this._deviceEntity.id, [data.entity.policyId]);
                break;
            case "policy":
                this._openPolicyView(data.entity.policyId, data.entity);
                break;
            case "violations":
                this._switchView(
                    Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS,
                    {isSubView: true},
                    data.entity
                );
                break;
        }
    }

    _runAll() {
        const ids = Object.values(this._pagingFeed.cache).map((entity) => entity.policyId);
        this._auditRun.runAllAudits(this._deviceEntity.id, ids);
    }

    _downloadSummary() {
        const _name = _.get(this._deviceEntity, "name", ""),
            _execDate = new Date();
        const timeZone = moment.tz.guess(),
            _fileNameTime = moment
                .tz(_execDate.toISOString(), timeZone)
                .format("YYYYMMDD_HHmmss_z");
        let _fileName = `AuditSummary_${_name}_${_fileNameTime}`;
        if (this._gameEditor.currentSolutionName === "device_manager") {
            _fileName = "DM_" + _fileName;
        } else {
            _fileName = "CDA_" + _fileName;
        }
        if (this._deviceEntity) {
            return this._deviceEntity.runAuditSummaryReportWork().then((data) => {
                this._fileFactory.saveStringAsFile(
                    data.summary.report,
                    _fileName + ".csv",
                    "text/csv"
                );
                return Promise.resolve();
            });
        }
        return Promise.resolve();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _hideResult(resultEntity) {
        // console.log(resultEntity);
        // this._deviceEntity.removeFromAuditSummaryRelationship(resultEntity.id);
        // this._deviceEntity.updateRelationships()
        //     .catch( err => this._logger.warn(err));

        BaseEntity.delete(
            this._gameEditor._activeOrgId,
            "ConfigAuditDeviceSummary",
            resultEntity.id
        ).catch((err) => {
            if (err.errorMsg === 'User not authorized for "Edit Devices"') {
                this._modalUserFeedback.displayError({
                    errorMsg: 'User not authorized for "Edit Devices"',
                    errorCode: "notAuthorized",
                });
            }
        });
    }

    _openPolicyView(pid, summaryEntity) {
        this._gameEditor._auditPolicyId = pid;
        this._ConfigAuditExecution
            .loadConfigAuditExecution(this._gameEditor._activeOrgId, summaryEntity.executionId)
            .then((entity) => {
                let pdview = new policyDetailsView(
                    this._logger,
                    this._gameEditor,
                    this._userSession,
                    this._muf,
                    this._steveIo,
                    this._deviceEntityDef,
                    this._customFieldsEntityDef,
                    this._siteEntityDef,
                    this._commandSetEntityDef,
                    {},
                    {},
                    this._tagsEntityDef,
                    entity.auditPolicy,
                    true,
                    true
                );
                this._childViewRenderer = new childViewComponent({
                    data: pdview.renderer.rootElement,
                    backLink: "Audit Summary",
                    title: "Policy Details",
                    childData: pdview,
                    parentData: this,
                    backButton: true,
                });

                return pdview.renderer.render();
            })
            .catch((err) => {
                this._logger.warn("AuditSummary::Open Policy view error", err);
                return Promise.resolve();
            });
    }

    _switchView(switchTo, params, summaryEntity) {
        this._ConfigAuditExecution
            .loadConfigAuditExecution(this._gameEditor._activeOrgId, summaryEntity.executionId)
            .then((entity) => {
                const _params = Object.assign(
                    {},
                    {
                        configExecutionEntity: entity,
                        isFrom: "AuditSummary",
                    },
                    params
                );
                this._gameEditor.setActiveView(
                    switchTo,
                    [
                        {
                            value: {
                                fqn: Registrations.DIE_VIEW_AUDIT_SUMMARY,
                                viewState: {configExecutionEntity: _params.configExecutionEntity},
                            },
                            content: "Audit Summary",
                            left: {
                                arrow: {
                                    direction: "left",
                                },
                            },
                        },
                    ],
                    _params
                );
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = AuditViewComponent;

AuditViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.io",
    "$teve.utils",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.entities.ConfigAuditDeviceSummary",
    "$teve.ui.userFeedback",
    "$teve.entities.ConfigAuditPolicy",
    "$teve.entities.Device",
    "$teve.entities.CustomFields",
    "$teve.entities.ConfigAuditExecution",
    "$teve.ui.userFeedback",
    "$teve.entities.Site",
    "$teve.entities.CommandSet",
    "$teve.entities.Tags",
];

AuditViewComponent.$displayDetails = {
    type: "View",
    name: "Audit Summary",
    icon: "configdrift.audit_policy",
    shown: true,
    title: "Audit Summary",
    order: 2,
};
